import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Superposition from '../components/Superposition';
import SideBySide from '../components/SideBySide';
import MiniatureList from '../components/MiniatureList';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ArrowLeft, ArrowRight, CheckCircle, XCircle, QuestionCircle, DashCircle, DashCircleDotted, PlusCircle, PlusCircleFill, PlusCircleDotted, Fullscreen, Download } from 'react-bootstrap-icons';
import axios from 'axios';
import './ComparePage.css';
import { DATASET, globalSetDataset, modeExecution, SITE_WEB } from './Global.js';
import iconeDB from '../images/icone_dashboard_2.png';
import { useNavigate } from 'react-router-dom';
import GraphDistances from '../components/GraphDistances.js';
import LoupeView from '../components/LoupeView';
import html2canvas from 'html2canvas';
import ManualOverlay from '../components/ManualOverlay.js';
import { Modal, Button } from 'react-bootstrap';
import Stroboscope from '../components/Stroboscope.js';
import Fade from '../components/Fade.js';
import Papa from 'papaparse';


const ComparePage = () => {

  const location = useLocation();
  const { isTreasureDataset, treasureName, datasetTreasure, datasetSingle, index = 0 } = location.state || {};  
  const [csvData, setCsvData] = useState([]);  

  const [view, setView] = useState('superposition');
  const [transformedPath1, setTransformedPath1] = useState('');
  const [transformedPath2, setTransformedPath2] = useState('');
  const [searchTerm1, setSearchTerm1] = useState('');
  const [searchTerm2, setSearchTerm2] = useState('');
  const [validations, setValidations] = useState({});
  const [distances, setDistances] = useState([]);
  const [rawValidations, setRawValidations] = useState([]);

  // const dataToDisplay = csvData ? csvData.slice(0, -1) : [];
  // const dataToDisplay = csvData.length > 0 ? csvData.slice(0, -1) : [];

  const [isTransformedPath1Ready, setIsTransformedPath1Ready] = useState(false);
  const [isTransformedPath2Ready, setIsTransformedPath2Ready] = useState(false);
  const navigate = useNavigate();
  const comparisonRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const [comment, setComment] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [showModifiyModal, setShowModifyModal] = useState(false);
  const [pairsList, setPairsList] = useState([]);
  const dataToDisplay = pairsList;
  const [nextPage, setNextPage] = useState(2); // commence à 2 après la première page
  const [showInitModal, setShowInitModal] = useState(true);
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [saveDone, setSaveDone] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [warningShown, setWarningShown] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(50);
  const [totalResults, setTotalResults] = useState(0);
  const [currentCsvIndex, setCurrentCsvIndex] = useState(null);

  const [pendingSearchTerm1, setPendingSearchTerm1] = useState('');
  const [pendingSearchTerm2, setPendingSearchTerm2] = useState('');
  const [isSearching, setIsSearching] = useState(false);

  let dataset = '';
  dataset = isTreasureDataset ? datasetTreasure : datasetSingle;

  if (!dataset) {
    return <div>Erreur : aucun dataset sélectionné.</div>;
  }
  else
    globalSetDataset(dataset); // pour le menu Dashboard





  function parseMatrix(matrixString) {

    if (matrixString === '0') {
        return [[0, 0, 0], [0, 0, 0]];
    }

    try {
        const cleanedString = matrixString.replace(/\[\s*/g, '[').replace(/\s*\]/g, ']').replace(/\s+/g, ' ');
        const rows = cleanedString.split('] [').map(row => {
            const trimmedRow = row.replace(/^\[\s*|\s*\]$/g, '');
            const values = trimmedRow.match(/-?\d+(\.\d+)?/g).map(value => parseFloat(value));
            return values;
        });
        return rows;
    } catch (error) {
        console.error('Erreur de parsing de la matrice :', error);
        return [[0, 0, 0], [0, 0, 0]];
    }
  } // parseMatrix



  
  useEffect(() => {
    console.log('[ComparePage] (useEffect [dataset 1]) *********** Start...');    
    if (!dataset) return;
    globalSetDataset(dataset);
    console.log("[ComparePage] (useEffect [dataset 1]) dataset : ", dataset);
    console.log("[ComparePage] (useEffect [dataset 1]) DATASET : ", DATASET);
    console.log('[ComparePage] (useEffect [dataset 1]) *********** ... Stop  ');      
  }, [dataset]);


  useEffect(() => {
    setPendingSearchTerm1(searchTerm1);
    setPendingSearchTerm2(searchTerm2);
  }, []);


  useEffect(() => {
    const fetchPairs = async () => {
      setIsSearching(true); 
      const token = sessionStorage.getItem('token');
      let route_tmp;        
      route_tmp = SITE_WEB + '/get-pairs-list-results'
      const response = await axios.get(route_tmp, {
        params: {
          dataset,
          searchTerm1,
          searchTerm2,
          page: currentPage,
          pageSize
        },
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setPairsList(response.data.pairs);
      setTotalResults(response.data.total);

      if (response.data.pairs.length > 0) {
        // Si la sélection courante n'est plus dans la nouvelle liste, sélectionne la première
        if (
          currentCsvIndex === null ||
          !response.data.pairs.some(p => p.csvIndex === currentCsvIndex)
        ) {
          setCurrentCsvIndex(response.data.pairs[0].csvIndex);
        }
        // Sinon, ne change rien (l'utilisateur a cliqué sur une paire)
      } else {
        setCurrentCsvIndex(null);
      }
      setIsSearching(false); // ← Ajoute ici
    };
    fetchPairs();
  }, [searchTerm1, searchTerm2, currentPage, dataset]);




  // useEffect(() => {
  //   console.log('[ComparePage] (useEffect [dataset 2][fetchPairsList]) *********** Start...');    
  //   if (!dataset) return;
  //   const fetchPairsList = async () => {
  //     try {
  //       const token = sessionStorage.getItem('token');
  //       let route_tmp;        
  //       route_tmp = SITE_WEB + '/get-pairs-list-results'
  //       const response = await axios.get(route_tmp, {
  //         params: { dataset, page: 1, pageSize: 50 },
  //         headers: { 'Authorization': `Bearer ${token}` }
  //       });
  //       setPairsList(response.data);
  //       setNextPage(2); 
  //       // console.log('[ComparePage] (fetchPairsList) response.data : ', response.data);
  //     } catch (err) {
  //       console.error('Erreur lors du chargement de la liste des paires :', err);
  //     }
  //   };
  //   fetchPairsList();
  //   console.log('[ComparePage] (useEffect [dataset 2][fetchPairsList]) *********** ... Stop  ');      
  // }, [dataset]);




  // Exemple pour charger la page suivante
  const loadNextPage = async () => {

    console.log('[ComparePage] (loadNextPage) *********** Start...');    
    setShowInitModal(true);
    const token = sessionStorage.getItem('token');
    let route_tmp;        
    route_tmp = SITE_WEB + '/get-pairs-list-results'

    const response = await axios.get(route_tmp, {
      params: { dataset, page: nextPage, pageSize: 50 },
      headers: { 'Authorization': `Bearer ${token}` }
    });
    // setPairsList(prev => [...prev, ...response.data]);
    setPairsList(prev => [...prev, ...response.data.pairs]);
    setNextPage(prev => prev + 1);
    setShowInitModal(false);
    console.log('[ComparePage] (loadNextPage) *********** ... Stop  ');      
  };




  useEffect(() => {
    console.log('[ComparePage] (useEffect [dataset 3][fetchDistances]) *********** Start...');    
    if (!dataset) return;
    const fetchDistances = async () => {

      const token = sessionStorage.getItem('token');
      const response = await axios.get(`${SITE_WEB}/get-distances`, {
        params: { dataset },
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setDistances(response.data.distances); 
      // console.log('Distances reçues :', response.data.distances);    
    };    
    fetchDistances();
    console.log('[ComparePage] (useEffect [dataset 3][fetchDistances]) *********** ... Stop  ');      
  }, [dataset]);






  useEffect(() => {
    console.log('[ComparePage] (useEffect [dataset, currentCsvIndex][fetchRow]) *********** Start...');    
    // if (!dataset) return;
    if (!dataset || currentCsvIndex === null || currentCsvIndex === undefined) return;

    const fetchRow = async () => {
      try {
        const token = sessionStorage.getItem('token');
        const response = await axios.get(`${SITE_WEB}/get-csv-row`, {
          params: { dataset, index: currentCsvIndex },
          headers: { 'Authorization': `Bearer ${token}` },
        });
        const row = response.data;
        console.log('[ComparePage] fetchRow - row.csvIndex:', row.csvIndex, row.name1, row.name2);
        // console.log('[ComparePage] fetchRow - currentCsvIndex:', currentCsvIndex);
        // console.log('[ComparePage] fetchRow - row.H:', row.H);
        row.matrix = parseMatrix(row.H);
        setCsvData([row]); 
      } catch (err) {
        alert('Erreur lors du téléchargement de la ligne du CSV');
      }
    };
    fetchRow();
    console.log('[ComparePage] (useEffect [dataset, currentCsvIndex][fetchRow]) *********** ... Stop  ');      
  }, [dataset, currentCsvIndex]);








  //*********** useEffect **************/
  useEffect(() => {
    const { isTreasureDataset, treasureName, datasetTreasure, datasetSingle, index = 0 } = location.state || {};  

    //ùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùù pour transfro path1
    const transformWithOpenCV = (imageSrc, matrix, callback) => {
      const img = new Image();
      // img.crossOrigin = 'Anonymous';
      img.src = imageSrc;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        const src = window.cv.imread(img);
        const matrix3x3 = convert2x3To3x3(matrix);

        const dsize = new window.cv.Size(img.width, img.height);
        const dst = new window.cv.Mat();
        const M = window.cv.matFromArray(3, 3, window.cv.CV_64F, matrix3x3.flat());

        window.cv.warpPerspective(
          src,
          dst,
          M,
          dsize,
          window.cv.INTER_LINEAR,
          window.cv.BORDER_CONSTANT,
          new window.cv.Scalar(255, 255, 255, 255)
        );

        const resultCanvas = document.createElement('canvas');
        window.cv.imshow(resultCanvas, dst);
        const transformedSrc = resultCanvas.toDataURL();
        // console.log("&&&&&&&&&&&&& transformedSrc : ", transformedSrc)
        src.delete();
        dst.delete();
        M.delete();

        callback(transformedSrc);

        setTransformedPath1(transformedSrc); // PATRICE
        setIsTransformedPath1Ready(true);// PATRICE
      };

      img.onerror = (err) => {
        console.error("[path1] Erreur lors du chargement de l'image :", err);
      };
    }; // FIN transformWithOpenCV


    //ùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùùù pour JEGERE transfo path2
    const transformPath2 = (imageSrc, callback) => {
      const img = new Image();
      // img.crossOrigin = 'Anonymous';
      img.src = imageSrc;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        const src = window.cv.imread(img);

        const resultCanvas = document.createElement('canvas');
        window.cv.imshow(resultCanvas, src);
        const transformedSrc = resultCanvas.toDataURL();
        src.delete();

        callback(transformedSrc);

        setTransformedPath2(transformedSrc); // PATRICE
        setIsTransformedPath2Ready(true); // PATRICE
      };

      img.onerror = (err) => {
        console.error("[path2] Erreur lors du chargement de l'image :", err);
      };
    }; // FIN transformPath2

    if (csvData.length > 0 && csvData[0]) {

      // const currentData = csvData[0];
      // const currentData = pairsList.find(pair => pair.csvIndex === currentCsvIndex) || {};
      const currentData = csvData[0] || {};
      const pairNumber = currentData.csvIndex !== undefined ? currentData.csvIndex + 1 : '';      
      if (!currentData) return;

      //-------------------- Token
      const token = sessionStorage.getItem('token');
      if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      }
      // console.log ("DATASET: ", DATASET)

      //-------------------- path1 
      let path1;
      if (isTreasureDataset) {
          path1 = SITE_WEB + '/images-treasure/' + currentData.name1;
          // console.log("path1 : ", path1);

          axios.get(path1, {
              params: { 
                  dataset: datasetTreasure,
                  treasure: treasureName 
              },
              headers: { 'Authorization': `Bearer ${token}` }, 
              responseType: 'blob', 
              withCredentials: true
          })
          .then(response => {
              const imageURL = URL.createObjectURL(response.data);

              console.log('1 currentData.H:', currentData.H);
              console.log('1 currentData.matrix:', currentData.matrix);              

              transformWithOpenCV(imageURL, currentData.matrix, (transformedSrc) => {
                setTransformedPath1(transformedSrc);
              });
          })
          .catch(error => {
              console.error("[path1] Erreur lors de la reception de la requete pour chargement image1 :", error);
          });
      } else {
        // Code existant pour les datasets single
        path1 = SITE_WEB + '/images/' + currentData.name1;
        // console.log("path1 : ", path1);

        axios.get(path1, {
            params: { dataset: DATASET },
            headers: { 'Authorization': `Bearer ${token}` },
            responseType: 'blob',
            withCredentials: true
        })
        .then(response => {
            const imageURL = URL.createObjectURL(response.data);

              console.log('2 currentData.H:', currentData.H);
              console.log('2 currentData.matrix:', currentData.matrix);              

              transformWithOpenCV(imageURL, currentData.matrix, (transformedSrc) => {
                setTransformedPath1(transformedSrc);
            });
        })
        .catch(error => {
            console.error("[path1] Erreur lors de la reception de la requete pour chargement image1 :", error);
        });
      }
      

      // SITE_WEB + '/images-treasure/' + currentData.name2;

      //-------------------- path2
      let path2 = currentData.name2 ? (isTreasureDataset 
        ? (SITE_WEB + '/images-treasure/' + currentData.name2)
        : (SITE_WEB + '/images/' + currentData.name2))
        : '';

      if (path2) {
        axios.get(path2, {
          params: isTreasureDataset 
                    ? { dataset: datasetTreasure, treasure: treasureName }
                    : { dataset: DATASET },
          headers: { 'Authorization': `Bearer ${token}` },
          responseType: 'blob',
          withCredentials: true
        })
          .then(response => {
            const path2ImageURL = URL.createObjectURL(response.data);
            transformPath2(path2ImageURL, (transformedSrc2) => {
              setTransformedPath2(transformedSrc2);
            });
          })
          .catch(error => {
            console.error("[path2] Erreur lors du chargement de l'image :", error);
          });
      }

    }
  }, [csvData, location.state]);


  


  useEffect(() => {
    if (pairsList.length > 0 && rawValidations.length > 0) {
      storeValidations(rawValidations, pairsList);
    }
  }, [pairsList, rawValidations]);






  const handleReturnDashboard = async () => {
    setShowSaveModal(true);
    const token = sessionStorage.getItem('token');
    await axios.post(`${SITE_WEB}/export-notations-csv`, {
      isTreasureDataset: isTreasureDataset,
      treasureName: treasureName  ,
      datasetTreasure: datasetTreasure,
      datasetSingle: datasetSingle
    }, { headers: { Authorization: `Bearer ${token}` } });
    setShowSaveModal(false);
    navigate('/dashboard');
  };




  //*********** useEffect **************/
  useEffect(() => {
    console.log('[ComparePage] (fetchValidations) *********** Start...');    

    const { isTreasureDataset, treasureName, datasetName, _index } = location.state || {};

    const fetchValidations = async () => {
      // Configuration d'Axios pour inclure le token
      const token = sessionStorage.getItem('token');
      // console.log(token)
      if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      }

      try {
        let response;

        let route_tmp;
        route_tmp = SITE_WEB + '/get-notations'
        console.log("[ComparePage] [fetchValidations] route /get-notations ... ")

        response = await axios.get(route_tmp, {
          params: { dataset: DATASET },
          headers: { 'Authorization': `Bearer ${token}` }
        });   

        const fetchedValidations = response.data;
        setRawValidations(fetchedValidations);        

        // console.log("[ComparePage] [fetchValidations] response : ", response)
        // console.log("[ComparePage] [fetchValidations] response.data : ", response.data)
        // console.log('[ComparePage] [fetchValidations] fetchedValidations:', fetchedValidations);

        storeValidations(fetchedValidations, dataToDisplay);
        // console.log("[ComparePage] [fetchValidations] dataToDisplay.length")

      } catch (error) {
        console.error('[ComparePage] [fetchValidations] Erreur lors de la récupération des validations :', error);
      }
    }; // fin fetchValidations

    fetchValidations();
    console.log('[ComparePage] (fetchValidations) *********** ... Stop  ');    
  }, []); // fin useEffect







  //*********** useEffect (comment) **************/
  useEffect(() => {
    console.log('[ComparePage] (fetchComment) *********** Start...');    
    
    const { isTreasureDataset, treasureName, datasetName, _index } = location.state || {};
    const fetchComment = async () => {
      const token = sessionStorage.getItem('token');
      if (!token) return;
  
      try {
        let response;

        let route_tmp;
        route_tmp = SITE_WEB + '/get-comment'
        console.log("[ComparePage] [fetchComment] route_tmp : ", route_tmp)
          
        response = await axios.get(route_tmp, {
          params: { 
            dataset: encodeURIComponent(DATASET),
            index: currentCsvIndex 
          },
          headers: { 'Authorization': `Bearer ${token}` }
        });
                    
        setComment(response.data.comment || '');
        const decodedComment = response.data.comment ? response.data.comment.replace(/\\n/g, '\n') : '';
        setComment(decodedComment);
      } catch (error) {
        console.error('Erreur lors de la récupération du commentaire:', error);
      }
    };
  
    fetchComment();

    console.log('[ComparePage] (fetchComment) *********** ... Stop  ');        
  }, [currentCsvIndex, location.state]);






useEffect(() => {
  console.log('pairsList:', pairsList.length, 'rawValidations:', rawValidations.length, 'distances:', distances.length);

  if (
    pairsList.length > 0 &&
    rawValidations.length > 0 &&
    distances.length > 0 &&
    !warningShown
  ) {
    setShowInitModal(false);
    setTimeout(() => {
      setShowWarningModal(true);
      setWarningShown(true); // Marquer comme affiché
    }, 300);
  }
}, [pairsList, rawValidations, distances, warningShown]);









  //*********** handleCommentChange **************/
  const handleCommentChange = (value) => {
    setComment(value);
  };




  
  //*********** handleSaveComment **************/
  const handleSaveComment = async () => {
    const { isTreasureDataset, treasureName, datasetName, _index } = location.state || {};
    setIsSaving(true);
    try {
      // Nettoyer le commentaire de tout retour à la ligne
      const cleanComment = comment.replace(/\n/g, ' ').trim();
      const token = sessionStorage.getItem('token');
      let response;

      let route_tmp;
      route_tmp = SITE_WEB + '/update-comment'
      console.log("[ComparePage] [handleSaveComment] route_tmp : ", route_tmp)

      response = await axios.post(route_tmp, {
        params: { dataset: DATASET },
        index: currentCsvIndex,
        comment: cleanComment
      }, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      console.log('Commentaire enregistré avec succès');
      handleCloseModifyModal();
    } catch (error) {
      console.error('Erreur lors de l\'enregistrement du commentaire:', error);
    } finally {
      setIsSaving(false);
    }
  };



  const handleSaveNotations = async () => {
    setShowSaveModal(true);
    setSaveDone(false);
    const token = sessionStorage.getItem('token');
    try {
      await axios.post(`${SITE_WEB}/export-notations-csv`, {
        isTreasureDataset: isTreasureDataset,
        treasureName: treasureName  ,
        datasetTreasure: datasetTreasure,
        datasetSingle: datasetSingle
      }, { headers: { Authorization: `Bearer ${token}` } });
      setSaveDone(true); // Affiche le message "Datas saved"
    } catch (err) {
      alert('Error while saving notations.');
      setShowSaveModal(false); // Ferme la modale seulement en cas d'erreur
    }
  };



  //*********** storeValidations **************/
  const storeValidations = (fetchedValidations, dataToDisplay) => {

    // console.log("[ComparePage] [storeValidations] (début) ...")

    // console.log('pairsList:', pairsList);
    // console.log('fetchedValidations:', fetchedValidations);

    const validationMap = dataToDisplay.reduce((acc, item, index) => {
      const validationItem = fetchedValidations.find(
        (validation) => validation.name1 === item.name1 && validation.name2 === item.name2
      );

      // Si une validation est trouvée, l'associer à l'index
      if (validationItem) {
        // console.log("[ComparePage] [storeValidations] validationItem found")
        acc[item.csvIndex] = validationItem.note;
      }
      else
        console.log("[ComparePage] [storeValidations ***] validationItem NOT found");

      return acc;
    }, {});

    // Mettre à jour l'état avec les validations
    setValidations(validationMap);
    // console.log("[ComparePage] [storeValidations] ... (fin)")

  }; // fin storeValidations


  //*********** handleValidation **************/
  const handleValidation = async (value, e) => {

    let _function = "handleValidation";

    // const { isTreasureDataset, treasureName, datasetName, _index } = location.state || {};
    sessionStorage.setItem('currentCsvIndex', currentCsvIndex);
    console.log(`[ComparePage] [${_function}] value:`, value);

    // Vérifier si la note actuelle est la même que celle sur laquelle on clique
    const currentValue = validations[currentCsvIndex];
    
    // console.log(`[ComparePage] [${_function}] currentValue:`, currentValue);

    const newValue = currentValue === value ? -1 : value;
    // console.log(`[ComparePage] [${_function}] newValue:`, newValue);

    setValidations((prevValidations) => ({
      ...prevValidations,
      [currentCsvIndex]: newValue,
    }));

    // *** AJOUT : mettre à jour rawValidations aussi ***
    setRawValidations((prevRaw) => {
      // On cherche la paire courante dans rawValidations
      //const currentData = pairsList.find(pair => pair.csvIndex === currentCsvIndex) || {};
      const currentData = csvData[0] || {};
      const pairNumber = currentData.csvIndex !== undefined ? currentData.csvIndex + 1 : '';      
      if (!currentData) return prevRaw;
      const idx = prevRaw.findIndex(
        (v) => v.name1 === currentData.name1 && v.name2 === currentData.name2
      );
      if (idx === -1) return prevRaw;
      // On crée une copie et on modifie la note
      const newRaw = [...prevRaw];
      newRaw[idx] = { ...newRaw[idx], note: newValue };
      return newRaw;
    });

    try {
      // Token
      const token = sessionStorage.getItem('token');
      if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      }

      let route_tmp;
      route_tmp = SITE_WEB + '/update-notation'
      console.log("[ComparePage] [handleValidation] route_tmp : ", route_tmp)

      let response;
      response = await axios.post(route_tmp, {
          params: { dataset: DATASET },
          index: currentCsvIndex,
          note: newValue === 1 ? 1 :
            newValue === 0.75 ? 0.75 :
              newValue === 0.25 ? 0.25 :
                newValue === 0.5 ? 0.5 :
                  newValue === 0 ? 0 : -1,
      });




      console.log('Validation enregistrée avec succès :', response.data, "newValue: ", newValue);
    } catch (error) {
      console.error('Erreur lors de l\'enregistrement de la validation :', error);
    }
  }; // fin handleValidation


  //*********** getButtonClass **************/
  const getButtonClass = (value) => {
    if (Number(validations[currentCsvIndex]) === Number(value)) {
      switch (value) {
        case 1:     return 'btn-success';
        case 0.75:  return 'btn-primary';
        case 0.5:   return 'btn-secondary';
        case 0.25:  return 'btn-warning';
        case 0:     return 'btn-danger';
        default:      return 'btn-light';
      }
    }
    return 'btn-light';
  }; // fin getButtonClass


  //*********** handleNext **************/
  const handleNext = () => {
  const idx = pairsList.findIndex(pair => pair.csvIndex === currentCsvIndex);
    if (idx < pairsList.length - 1) {
      setCurrentCsvIndex(pairsList[idx + 1].csvIndex);
    }
  };

  //*********** handlePrevious **************/
  const handlePrevious = () => {
    const idx = pairsList.findIndex(pair => pair.csvIndex === currentCsvIndex);
    if (idx > 0) {
      setCurrentCsvIndex(pairsList[idx - 1].csvIndex);
    }
  };

  //*********** handleSelect **************/
  // const handleSelect = (index) => {
  //   setCurrentIndex(index);
  // };
  const handleSelect = (csvIndex) => {
    setCurrentCsvIndex(csvIndex);
  };  

  //*********** convert2x3To3x3 **************/
  // const convert2x3To3x3 = (matrix2x3) => {
  //   // console.log('convert2x3To3x3 reçoit :', matrix2x3);
  //   return [
  //     [matrix2x3[0][0], matrix2x3[0][1], matrix2x3[0][2]],
  //     [matrix2x3[1][0], matrix2x3[1][1], matrix2x3[1][2]],
  //     [0, 0, 1],
  //   ];
  // };
  const convert2x3To3x3 = (matrix2x3) => {
    console.log('convert2x3To3x3 reçoit :', matrix2x3);

    // Sécurisation : vérifie que matrix2x3 est bien un tableau 2x3
    if (
      !Array.isArray(matrix2x3) ||
      matrix2x3.length !== 2 ||
      !Array.isArray(matrix2x3[0]) ||
      !Array.isArray(matrix2x3[1]) ||
      matrix2x3[0].length !== 3 ||
      matrix2x3[1].length !== 3
    ) {
      console.warn('convert2x3To3x3 appelé avec une valeur invalide :', matrix2x3);
      // Retourne une matrice identité par défaut pour éviter le crash
      return [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1],
      ];
    }

    return [
      [matrix2x3[0][0], matrix2x3[0][1], matrix2x3[0][2]],
      [matrix2x3[1][0], matrix2x3[1][1], matrix2x3[1][2]],
      [0, 0, 1],
    ];
  };  

  //*********** handleDownloadComparison **************/
  const handleDownloadComparison = async () => {
    try {
      const zoomLevel = Math.round((window.outerWidth / window.innerWidth) * 100) / 100;
      console.log('Zoom level:', zoomLevel);

      if (zoomLevel !== 1) {
        alert('Your browser zoom is not at 100%. Please set your zoom level to 100% for optimal image quality.');
        // return;
      }
    
      // sous-menu
      const subMenuDiv = document.getElementById('subMenu');
      const sliderDiv = document.querySelector('.slider-for-screen-only');
      let oldDisplay = '';
      let oldSliderDisplay = '';


      if (subMenuDiv) {
        oldDisplay = subMenuDiv.style.display;
        subMenuDiv.style.display = 'none';
      }

      if (sliderDiv) {
        oldSliderDisplay = sliderDiv.style.display;
        sliderDiv.style.display = 'none';
    }

      const comparisonDiv = document.getElementById('comparison-view');
      if (!comparisonDiv) return;

      const dimensions = {
        sideBySide: {
            width: 1200,
            height: 650
        },
        superposition: {
            width: 750,
            height: 650,
        },
        loupe: {
            width: 750,
            height: 650
        },
        fade: {
            width: 750,
            height: 650
        }
      };

      const { width, height } = dimensions[view] || dimensions.superposition;


      const canvas = await html2canvas(comparisonDiv, {
        useCORS: true,
        backgroundColor: '#000',
        width: width,
        height: height,
        scale: 1,
        x: view === 'superposition' ? 185 : 
           view === 'sideBySide' ? - 40 : 
           view === 'loupe' ? 185 :
           view === 'fade' ? 185 : 0,
        y: view === 'superposition' ? - 10 :
           view === 'sideBySide' ? 0 :
           view === 'loupe' ? - 10 :
           view === 'fade' ? - 10 : 50
      });

      // Restaurer les éléments cachés
      if (subMenuDiv) {
        subMenuDiv.style.display = oldDisplay;
      }
      if (sliderDiv) {
          sliderDiv.style.display = oldSliderDisplay;
      }

      const ctx = canvas.getContext('2d');
      ctx.save();
      ctx.textAlign = 'start';
      ctx.textBaseline = 'bottom';
      ctx.fillStyle = 'rgb(255, 255, 255)';
      ctx.font = 'bold 20px Arial';

      let textX, textY;
      if (view === 'sideBySide') {
        textX = canvas.width - 310;
        textY = canvas.height + 190;
      } else {
        // modes Overlay, Loupe, Fade
        textX = canvas.width + 155; 
        textY = canvas.height + 160;
      }

      ctx.fillText('©ACCADIL', textX, textY);
      ctx.restore();

      // const currentData = pairsList.find(pair => pair.csvIndex === currentCsvIndex) || {};      
      const currentData = csvData[0] || {};
      const pairNumber = currentData.csvIndex !== undefined ? currentData.csvIndex + 1 : '';      
      const dataURL = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = dataURL;
      link.download = `${currentData.name1}-${currentData.name2}.png`;
      link.click();
    } catch (err) {
      console.error('Capture error:', err);
    }
  };


  //*********** filteredCsvData **************/
  // // const filteredCsvData = dataToDisplay.filter((result) => {
  // const filteredCsvData = pairsList.filter((result) => {
  //   const name1 = result.name1 ? result.name1.toLowerCase() : '';
  //   const name2 = result.name2 ? result.name2.toLowerCase() : '';
  //   const term1 = searchTerm1.toLowerCase();
  //   const term2 = searchTerm2.toLowerCase();

  //   return (
  //     (name1.startsWith(term1) || name2.startsWith(term1)) &&
  //     (name1.startsWith(term2) || name2.startsWith(term2))
  //   );
  // }); // fin filteredCsvData
  const filteredCsvData = pairsList;

  // Raccourcis clavier pour télécharger la comparaison
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'F2' && view !== 'superposition') {
        e.preventDefault();
        handleDownloadComparison();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleDownloadComparison, view]);


  // On fait le test APRES les hooks
  // if (dataToDisplay.length === 0) {
  //   return <div>Chargement des données...</div>;
  // }

  // const currentData = pairsList.find(pair => pair.csvIndex === currentCsvIndex) || {};
  const currentData = csvData[0] || {};
  const pairNumber = currentData.csvIndex !== undefined ? currentData.csvIndex + 1 : '';  
  const name1 = currentData.name1 || 'Nom non disponible';
  const name2 = currentData.name2 || 'Nom non disponible';

  // On formatte la distance à 3 décimales
  const dist3 = currentData.distance
    ? parseFloat(currentData.distance).toFixed(3)
    : null;

  // Fonction pour basculer en plein écran
  const handleFullscreen = () => {
    const el = comparisonRef.current;
    if (!el) return;

    // On vérifie si on est déjà en fullscreen
    if (!document.fullscreenElement) {
      el.requestFullscreen().catch(err => {
        console.error("Unable to go full screen:", err);
      });
    } else {
      document.exitFullscreen();
    }
  };

  const handleShowPopup = () => setShowPopup(true);
  const handleClosePopup = () => setShowPopup(false);

  const handleShowModifyModal = () => setShowModifyModal(true);
  const handleCloseModifyModal = () => setShowModifyModal(false);

  // if (dataToDisplay.length === 0) {
  //   return <div>Chargement des données...</div>;
  // }
  const currentPos = pairsList.findIndex(pair => pair.csvIndex === currentCsvIndex);

  return (
    <div className="compare-page container-fluid p-3">

      {/* {showSaveModal && (
        <div className="custom-modal-backdrop">
          <div className="custom-modal">
            <div className="custom-modal-header">
              <h5 className="modal-title">Saving...</h5>
            </div>
            <div className="custom-modal-body">
              <p>Saving permanently the results of your current dataset...</p>
            </div>
          </div>
        </div>
      )} */}


      {isSearching && (
        <div className="custom-modal-backdrop">
          <div className="custom-modal">
            <div className="custom-modal-header">
              <h5 className="modal-title">Searching in database...</h5>
            </div>
            <div className="custom-modal-body">
              <p>Please wait...</p>
            </div>
          </div>
        </div>
      )}

      {showSaveModal && (
        <div className="custom-modal-backdrop">
          <div className="custom-modal">
            <div className="custom-modal-header">
              <h5 className="modal-title">
                {saveDone ? "Datas saved" : "Saving..."}
              </h5>
            </div>
            <div className="custom-modal-body">
              {saveDone ? (
                <>
                  <p>Datas saved.</p>
                  <button className="btn btn-primary" onClick={() => setShowSaveModal(false)}>
                    OK
                  </button>
                </>
              ) : (
                <p>Saving permanently the results of your current dataset...</p>
              )}
            </div>
          </div>
        </div>
      )}

      {showInitModal && (
        <div className="custom-modal-backdrop">
          <div className="custom-modal">
            <div className="custom-modal-header">
              <h5 className="modal-title">Init datas for comparisons...</h5>
            </div>
            <div className="custom-modal-body">
              <p>Loading, please wait...</p>
            </div>
          </div>
        </div>
      )}      

      {/* PATRICE : mode dev : pour afficher le H et l'index selectionné */}
      {/* <div style={{background: "#eee", padding: "8px", margin: "8px 0", fontSize: "12px"}}>
        <b>currentCsvIndex :</b> {currentCsvIndex}<br />
        <b>H :</b> {currentData.H ? JSON.stringify(currentData.H) : "Aucune valeur"}
      </div> */}

      <div className="row">

        {/* Liste des résultats à gauche */}
        <div className="col-lg-3 col-xl-2 d-none d-lg-block mb-3">
          {/* Icone retour dashboard */}
          <div className="return-dashboard-button">
            {/* <button onClick={() => navigate('/dashboard')}> */}
            <button onClick={handleReturnDashboard}>
                <ArrowLeft style={{ fontSize: '50px' }} />
                <span>Dashboard</span>
            </button>
         </div>
         

          {/* Bouton pour afficher le popup */}
          <button
              // className="btn btn-custom-shortcuts mb-2"
              className="btn btn-secondary btn-sm ms-auto"
              // className="btn btn-custom-loadpairs mb-2"     
                       
              style={{ marginRight: '10px', marginBottom: '10px', width: '100%', marginTop: '10px' }}
              onClick={handleShowPopup}
            >
              Shortcuts
            </button>

          <button
              // className="btn btn-custom-save mb-2"
              // className="btn btn-primary btn-sm ms-auto"
              className="btn btn-secondary btn-sm ms-auto"
              // className="btn btn-custom-loadpairs mb-2"              
              style={{ marginBottom: '10px', width: '100%' }}
              onClick={handleSaveNotations}
            >
              Save...
            </button>

          {/* Bouton pour charger la page suivante */}
          <button
              // className="btn btn-custom-loadpairs mb-2"
              // className="btn btn-primary btn-sm ms-auto"
              className="btn btn-secondary btn-sm ms-auto"
              style={{ width: '100%' }}
              onClick={loadNextPage}
            >
              Load more pairs
          </button>

          {/* Champs de recherche */}
          {/* <input
            type="text"
            placeholder="Search..."
            className="form-control mb-2"
            value={searchTerm1}
            onChange={(e) => setSearchTerm1(e.target.value)}
          />
          <input
            type="text"
            placeholder="Search..."
            className="form-control mb-3"
            value={searchTerm2}
            onChange={(e) => setSearchTerm2(e.target.value)}
          /> */}

          <div className="input-group mb-2">
            <input
              type="text"
              placeholder="Search..."
              className="form-control"
              value={pendingSearchTerm1}
              onChange={(e) => setPendingSearchTerm1(e.target.value)}
            />
            <button
              className="btn btn-outline-primary"
              type="button"
              onClick={() => setSearchTerm1(pendingSearchTerm1)}
              title="Start search"
            >
              Update
            </button>
          </div>
          <div className="input-group mb-3">
            <input
              type="text"
              placeholder="Search..."
              className="form-control"
              value={pendingSearchTerm2}
              onChange={(e) => setPendingSearchTerm2(e.target.value)}
            />
            <button
              className="btn btn-outline-primary"
              type="button"
              onClick={() => setSearchTerm2(pendingSearchTerm2)}
              title="Start search"
            >
              Update
            </button>
          </div>

          {/* miniatures */}
          <div className="miniature-list-container overflow-auto">

            <MiniatureList
              csvData={filteredCsvData}
              currentCsvIndex={currentCsvIndex}
              onSelect={handleSelect}
              originalData={pairsList}
              validations={validations} // Add this line
            />
          </div>
        </div>

        {/* Outils de comparaison à droite */}
        <div className="col-lg-8 col-xl-8 col-md-8 d-flex flex-column align-items-center">

          <h1><strong>{DATASET}</strong></h1>

          <h2>
            {/* Pair n° {currentIndex + 1} */}
            Pair n° {pairNumber}
            {dist3 !== null && (
              <> (Distance: {dist3})</>
            )}
          </h2>

          <h6>{name1} ---- {name2}</h6>

          <div className="d-flex justify-content-between align-items-center">
          {view !== 'superposition' && (
            <button className="btn btn-outline-primary" onClick={handleDownloadComparison}>
              <Download />
            </button>
          )}

            {/* Bouton pour afficher le mode plein écran */}
            {/* <button className="btn btn-outline-primary" onClick={handleFullscreen}>
              <Fullscreen />
            </button> */}
          </div>

          <div className="comment-section" style={{
            position: 'absolute',
            top: '20px',
            right: '150px',
            width: '300px',
            zIndex: 1000
          }}>
            <div className="form-group">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <label htmlFor="commentArea" className="form-label mb-0">Comment</label>
                
              </div>
              <textarea
                id="commentArea"
                className="form-control"
                value={comment}
                onChange={(e) => handleCommentChange(e.target.value)}
                rows="4"
                placeholder="Add your comment here..."
                style={{
                  resize: 'none',
                  height: '150px',
                  width: '430px',
                }}
                disabled
              />
              <div className="d-flex justify-content-end w-100">
              <button 
                  className="btn btn-primary btn-sm ms-auto"
                  // className="btn btn-secondary btn-sm ms-auto"
                  // className="btn btn-custom-loadpairs mb-2"
                  onClick={handleShowModifyModal}
                >
                  Modify
                </button>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center align-items-center w-100 gap-1">

            {/* LEFT BUTTON */}
            <button
              className="btn btn-secondary mx-1"
              onClick={handlePrevious}
              disabled={currentPos <= 0}
            >
              <ArrowLeft />
            </button>

            {/* COMPARISON */}
            <div id="comparison-view" ref={comparisonRef} className="d-flex align-items-center flex-grow-1 justify-content-center">
              {isTransformedPath1Ready && isTransformedPath2Ready && (
                <>
                  {/* Mode superposition */}
                  {view === 'superposition' && (
                    <Superposition path1={transformedPath1} path2={transformedPath2} />
                  )}

                  {/* Mode sideBySide */}
                  {view === 'sideBySide' && (
                    <SideBySide path1={transformedPath1} path2={transformedPath2} />
                  )}

                  {/* Mode loupe */}
                  {view === 'loupe' && (
                    <LoupeView path1={transformedPath1} path2={transformedPath2} />
                  )}

                  {/* Mode stroboscope */}
                  {view === 'stroboscope' && (
                    <Stroboscope path1={transformedPath1} path2={transformedPath2} />
                  )}

                  {/* Mode fade */}
                  {view === 'fade' && (
                    <Fade path1={transformedPath1} path2={transformedPath2} />
                  )}
                </>
              )}
            </div>

            {/* RIGHT BUTTON */}
            <button
              className="btn btn-secondary mx-1"
              onClick={handleNext}
              disabled={currentPos === -1 || currentPos === pairsList.length - 1}
            >
              <ArrowRight />
            </button>
          </div>

          {/* COMPARISION MODE */}
          <div className="view-toggle-buttons mb-3">
            {/* overlay */}
            <button
              className={`btn btn-primary ${view === 'superposition' ? 'active' : ''}`}
              onClick={() => setView('superposition')}
            >
              Overlay
            </button>

            {/* Side by side */}
            <button
              className={`btn btn-primary ${view === 'sideBySide' ? 'active' : ''}`}
              onClick={() => setView('sideBySide')}
            >
              Side by side
            </button>

            {/* Loupe */}
            <button
              className={`btn btn-primary ${view === 'loupe' ? 'active' : ''}`}
              onClick={() => setView('loupe')}
            >
              Loupe
            </button>

            {/* Stroboscope */}
            {/* <button
              className={`btn btn-primary ${view === 'stroboscope' ? 'active' : ''}`}
              onClick={() => setView('stroboscope')}
            >
              Stroboscope
            </button> */}

            {/* Fade */}
            <button
              className={`btn btn-primary ${view === 'fade' ? 'active' : ''}`}
              onClick={() => setView('fade')}
            >
              Fade
            </button>
          </div>

          {/* <button className="btn btn-secondary" onClick={handleDownloadComparison}>
            Download Comparison
          </button>

          <button className="btn btn-outline-primary" onClick={handleFullscreen}>
            <Fullscreen />
          </button> */}

          {/* NOTATION BUTTONS */}
          <div className="btn-group btn-group-lg justify-content-center" role="group" aria-label="Basic outlined example">
            <button
              type="button"
              className={`btn ${getButtonClass(1)}`}
              onClick={(e) => handleValidation(1, e)}
            >
              <PlusCircle />
            </button>
            <button
              type="button"
              className={`btn ${getButtonClass(0.75)}`}
              onClick={(e) => handleValidation(0.75, e)}
            >
              <PlusCircleDotted />
            </button>
            <button
              type="button"
              className={`btn ${getButtonClass(0.5)}`}
              onClick={(e) => handleValidation(0.5, e)}
            >
              <QuestionCircle />
            </button>
            <button
              type="button"
              className={`btn ${getButtonClass(0.25)}`}
              onClick={(e) => handleValidation(0.25, e)}
            >
              <DashCircleDotted />
            </button>
            <button
              type="button"
              className={`btn ${getButtonClass(0)}`}
              onClick={(e) => handleValidation(0, e)}
            >
              <DashCircle />
            </button>
          </div>

          {/* DISPLAY NOTATION */}
          <p>
            {/* Current notation :{' '} */}
            {validations[currentCsvIndex] === 1
              ? 'Linked'
              : validations[currentCsvIndex] === 0
                ? 'Not linked'
                : validations[currentCsvIndex] === 0.5
                  ? 'Don\'t know'
                  : validations[currentCsvIndex] === 0.75
                    ? 'Probably linked'
                    : validations[currentCsvIndex] === 0.25
                      ? 'Probably not linked'
                      : 'Not evaluated'}
          </p>

          <div className="graph-container">
            <GraphDistances distances={distances} highlightIndex={currentCsvIndex} />
            {/* {memoizedGraphDistances} */}
          </div>
        </div>
      </div>

      {/* Modal pour afficher les fonctionnalités et raccourcis */}
      <Modal show={showPopup} onHide={handleClosePopup} styles={{ zIndex: 9999 }}>
        <Modal.Header closeButton>
          <Modal.Title>Shortcuts</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            <li><strong>F2</strong> : Download the comparison image.</li>
            <li><strong>+/-</strong> : Increases/decreases the size of the "Loupe".</li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClosePopup}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal pour modifier le commentaire */}
      <Modal show={showModifiyModal} onHide={handleCloseModifyModal} size="lg" styles={{ zIndex: 9999 }}>
        <Modal.Header closeButton>
          <Modal.Title>Modify Comment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="alert alert-info">
            Note: Line breaks are not allowed in comments.
          </div>
          <textarea
            className="form-control"
            value={comment}
            onChange={(e) => {
              // Remplacer tous les retours à la ligne par des espaces
              const newValue = e.target.value.replace(/\n/g, ' ');
              handleCommentChange(newValue);
            }}
            rows="4"
            placeholder="Add your comment here..."
            style={{
              height: '450px',
              maxHeight: '450px',
              minHeight: '450px',
              width: '750px',
              minwidth: '749px',
              maxWidth: '750px',
              resize: 'none',
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModifyModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveComment} disabled={isSaving}>
            {isSaving ? 'Saving...' : 'Save'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showWarningModal} onHide={() => setShowWarningModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Please remember to save your data frequently (with the <b>Save...</b> button),
          and <b>especially before leaving ACCADIL</b>..
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowWarningModal(false)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>      
    </div>
  );
};

export default ComparePage;
